const env = location.host.split('.')[0].match(/(qc|box)\d?/g)
const spell = !!env ? (env.length > 0 ? `-${env[0]}` : '') : ''
const WXDOMAIN = `//wx${spell}.xinli001.com/`,
  LXDOMAIN = `//m-lingxi${spell}.xinli001.com/lingxi/service/`,
  // 临时域名
  // LXDOMAIN = `//promo-lingxi${spell}.xinli001.com/lingxi/service/`,
  YIAPI = `//yiapi${spell}.xinli001.com/v5/yi/`,
  APIS = {
    // 头条接口
    myRewardList: `${LXDOMAIN}promo/myRewardList`, // 推广中心-收益列表
    promoQrcodeList: `${LXDOMAIN}promo/qrcodeList`, // 推广中心-推广码列表
    promoGetUser: `${LXDOMAIN}promo/getUser`, // 推广中心-获取用户信息
    promoGetQrCode: `${LXDOMAIN}promo/getQrCode`, // 推广中心-获取推广码
    myReward: `${LXDOMAIN}promo/myReward`, // 推广中心-收益总览
    getBindToutiaoUsers: `${LXDOMAIN}promo/getBindToutiaoUsers`, // 推广中心-绑定抖音号昵称
    getRealNameInfo: `${LXDOMAIN}promo/getRealNameInfo`, // 推广中心-获取实名认证信息
    saveRealNameInfo: `${LXDOMAIN}promo/saveRealNameInfo`, // 推广中心-提交实名认证信息
    withdrawList: `${LXDOMAIN}promo/withdrawList`, // 推广中心-提现明细
    withdraw: `${LXDOMAIN}promo/withdraw`, // 推广中心-申请提现
    promoTeamRewards: `${LXDOMAIN}promo/teamRewards`, // 推广中心-我的团队收益
    promoBind: `${LXDOMAIN}promo/bind`, // 推广中心-绑定推荐人
    promoGetPromoCard: `${LXDOMAIN}promo/getPromoCard`, // 推广中心-生成分销卡
    getStatisticData: `${LXDOMAIN}promo/getStatData`, // 推广中心-统计数据
    getCooperationPdf: `${LXDOMAIN}promo/getCooperationPdf`, // 获取推广中心服务协议阅读状态、pdf链接
    promoAuthUrl : `${LXDOMAIN}promo/authUrl`, // 获取授权码链接
    promoAppList: `${LXDOMAIN}promo/miniAppList`, // 获取小程序列表

    myRewardListDay: `${LXDOMAIN}promo/ad/myRewardList`, // 推广中心-每日收益列表
    myRewardDay: `${LXDOMAIN}promo/ad/myReward`, // 推广中心-每日收益总览
    myTeamRewardDay: `${LXDOMAIN}promo/ad/myTeamReward`, // 推广中心-每日团队收益总览
    withdrawDay: `${LXDOMAIN}promo/ad/withdraw`, // 推广中心-每日申请提现
    withdrawListDay: `${LXDOMAIN}promo/ad/withdrawList`, // 推广中心-提现明细
    admyTeamRewardList: `${LXDOMAIN}promo/ad/myTeamRewardList`, // 推广中心-团队贡献排行榜

    promoSearchScale: `${LXDOMAIN}promo/searchFunScale`, // 推广中心-搜索测试
    promoSearchScaleCode: `${LXDOMAIN}promo/getPromoCode`, // 推广中心-测试生成推广码
    promoUserAuthList: `${LXDOMAIN}promo/userAuthList`, // 推广中心-多身份的身份列表

    uploadImage: `${LXDOMAIN}uploadImg`, // 上传图片

    sendValidcode: `${YIAPI}send-validcode.json`, // 发送验证码
    validcodeLogin: `${YIAPI}phone-validcode-login.json`, // 验证码登陆验证
    getADStatData : `${LXDOMAIN}promo/advertReward`, // 广告收益明细
    promoPackagePop: `${LXDOMAIN}promo/packagePop`, // 推广中心资料包弹窗控制

  }

export default APIS



// WEBPACK FOOTER //
// ./src/apis/toutiao.js